@use '../../../../app/styles/common/mixins';

.card {
  display: flex;
  flex-direction: column;
  gap: var(--spasing12);
  padding: var(--spasing16);
  border-radius: var(--rounding16);
  background-color: var(--surface-01);
  height: 100%;
  overflow: hidden;

  @include mixins.tablet {
    gap: var(--spasing24);
    border-radius: var(--rounding20);
  }

  @include mixins.laptop {
    flex: 0 1 500px;
    border: 1px solid var(--border-primary);
  }
}

.cardLink {
  text-decoration: none;
  color: var(--fg-primary);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--spasing12);
  width: 100%;

  @include mixins.laptop {
    align-items: flex-start;
    gap: var(--spasing16);
  }
}

.imageWrapper {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: var(--rounding12);
  overflow: hidden;
  background-color: var(--surface-00);

  @include mixins.laptop {
    width: 70px;
    height: 70px;
    border-radius: var(--rounding16);
  }
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--spasing06);
  flex: 1 1 0;
  min-width: 0;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: var(--spasing04);
  width: 100%;
}

.title {
  @include mixins.heading-secondary-200;
  color: var(--fg-primary);
  margin: 0;

  @include mixins.tablet {
    @include mixins.heading-primary-300;
  }
}

.titleChevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  & path {
    fill: var(--fg-primary);
  }
}

.subtitle {
  @include mixins.caption-primary-400;
  color: var(--fg-primary);

  @include mixins.tablet {
    font-size: 16px;
    line-height: 19px;
  }
}

.cta {
  margin-top: auto;
}
